import { useEffect, useRef } from "react";

export default function CustomCursor() {
  const ref = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const fine = window.matchMedia("(pointer: fine)").matches;
    if (reduced || !fine) return;
    const el = ref.current;
    let raf = 0;
    let x = -100, y = -100, tx = -100, ty = -100;
    const move = (e) => { tx = e.clientX; ty = e.clientY; };
    const over = (e) => {
      const hot = e.target.closest?.('[data-cursor="cta"], a, button');
      el.style.width = el.style.height = hot ? "28px" : "12px";
    };
    const loop = () => {
      x += (tx - x) * 0.2;
      y += (ty - y) * 0.2;
      el.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="hidden lg:block fixed top-0 left-0 z-[100] pointer-events-none rounded-full bg-[#0162CA] mix-blend-screen opacity-80"
      style={{ width: 12, height: 12, transition: "width 0.25s ease, height 0.25s ease" }}
    />
  );
}
